var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraserSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.5H0V10.5H14V0.5ZM2.07667 17.216L0.221667 14.9557L0.229446 14.9517C0.0816683 14.8037 0 14.5997 0 14.3877V12.5L14 12.5V14.3917C14 14.6037 13.9183 14.8037 13.7706 14.9557L11.9156 17.216C11.7678 17.396 11.55 17.5 11.3206 17.5L2.67167 17.5C2.44222 17.5 2.22445 17.396 2.07667 17.216Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserSmall);
export default __webpack_public_path__ + "static/media/eraser-small.f30a91123e7f75a5ea57c3de00abc0e1.svg";
export { ForwardRef as ReactComponent };